import axios from 'axios';

import { isLegalAgreementRequiredError } from './Legal.api';

type Listener = () => void;

let required = false;
const listeners = new Set<Listener>();
let interceptorInstalled = false;

function notify(): void {
  listeners.forEach((listener) => listener());
}

/** Текущее состояние: interceptor попросил показать модалку согласия. */
export function getLegalAgreementRequired(): boolean {
  return required;
}

export function requestLegalAgreement(): void {
  if (required) {
    return;
  }
  required = true;
  notify();
}

export function clearLegalAgreementRequired(): void {
  if (!required) {
    return;
  }
  required = false;
  notify();
}

export function subscribeLegalAgreementRequired(
  listener: Listener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Response interceptor: 403 + legal_agreement_required → открыть модалку согласия.
 * Ошибку не глотает (мутации по-прежнему получают reject).
 */
export function installLegalAgreementInterceptor(): void {
  if (interceptorInstalled) {
    return;
  }
  interceptorInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    (error: unknown) => {
      if (isLegalAgreementRequiredError(error)) {
        requestLegalAgreement();
      }
      return Promise.reject(error);
    },
  );
}
